<template lang="pug">
.book(:class="{'u-mt-md': !book.styles || !book.styles.length || (book.styles.length === 1 && book.styles[0].class === 'is-dark' ) }")
  .book-header(v-if="intro")
    Content
      div(v-html="book.intro")

  ChaptersNav(tag="section" :chapters="book.chapters.edges" :bookSlug="book.slug" v-if="intro" :chapterText="$t('chapterText')" :chaptersText="$t('chaptersText')")

  section.book-content(:class="{ 'u-mt-md': intro }")
    .book-sticky-nav
      a(href="#" @click.prevent="showTableOfContents" title="title" class="book-navAll") #[span] #[span] #[span] #[span]
      ul
        li
          AppLink(:to="`/books/${book.slug}`")
            span 0
        li(v-for="({ node }, n) in book.chapters.edges" :key="node.title")
          AppLink(:to="`/books/${book.slug}/${node.slug}`" :title="`Chapter ${n + 1}: ${node.title}`")
            span {{ n + 1 }}
    slot
  Overlay(:isOpen.sync="showNav" :centered="true")
    ChaptersNav(tag="div" :chapters="book.chapters.edges" :bookSlug="book.slug" :chapterText="$t('chapterText')" :chaptersText="$t('chaptersText')")

</template>

<script>
import ChaptersNav from './ChaptersNav';
import Content from '../Content';
import Overlay from '~/components/Overlay';

export default {
  name: 'BookView',
  components: {
    ChaptersNav,
    Content,
    Overlay
  },
  props: {
    book: {
      type: Object,
      required: true
    },
    intro: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    chapters: [],
    showNav: false
  }),
  computed: {
    orderedChapters() {
      return [...this.chapters].sort((a, b) => {
        return a.index - b.index;
      });
    }
  },
  methods: {
    showTableOfContents() {
      this.showNav = true;
    }
  }
};
</script>

<style lang="stylus">
.bookNav
  position: relative
  display: flex
  flex-wrap: wrap
  margin-right: -1.5%
  margin-left: -1.5%

  &-item
    position: relative
    flex: 0 0 calc((100% / 3))
    width: calc((100% / 3))
    margin-bottom: 3%
    padding: 0 1.5%

    +mq($until: 'desktop')
      flex: 0 0 calc((100% / 2))
      width: calc((100% / 2))

    +mq($until: 500px)
      flex: 0 0 100%
      width: 100%

.book
  &-content
    position: relative

  &-sticky-nav
    position: fixed
    left: 8vw
    top: 50%
    transform: translate3d(0, -50%, 0)
    display: flex
    flex-direction: column
    align-items: flex-start
    z-index: 2

    ul
      display: flex
      flex-direction: column
      align-items: flex-start
      list-style-type: none

      a
        display: flex
        align-items: center

        span
          opacity: 0
          transition: 160ms

        &:before
          content: ''
          display: block
          width: unitRes(16, 32)
          height: unitRes(3, 5)
          margin: unitRes(5, 10) unitRes(5, 10) unitRes(5, 10) 0
          background-color: $clBlack
          cursor: pointer
          transition: 160ms

        &:hover, &.is-active
          &:before
            background-color: $clPrimary
            width: unitRes(16, 32)

          span
            opacity: 1
            color: $clPrimary

    +mq($until: 'desktop')
      left: 5px

    +mq($until: 'tablet')
      display: none

  &-navAll
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    width: unitRes(16, 32)
    height: unitRes(16, 32)
    margin-bottom: unitRes(20, 40)
    align-content: space-between

    span
      height: 45%
      width: 45%
      display: inline-flex
      border: unitRes(2, 4) solid $clBlack
      transition: 200ms

    &:hover
      border-color: $clPrimary
</style>

<i18n>
{
  "en": {
    "chaptersText":"Chapters",
    "chapterText":"Chapter"
  },
  "ar": {
    "chaptersText":"الفصول",
    "chapterText":"فصل"
  }
}
</i18n>
